export default "__VITE_ASSET__B6odya8H__"